export const HamburgerIcon = (p: { lightMode?: boolean }) => {
  return (
    <svg
      class="w-6 h-6"
      aria-hidden="true"
      fill={p.lightMode ? "#000000" : "#ffffff"}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
        clip-rule="evenodd"
      ></path>
    </svg>
  );
};

export default HamburgerIcon;
